import styles from "./toolbar-unselected-element.module.css";

interface ToolboxUnselectedElementProps {
  title: string;
}

export const ToolboxUnselectedElement = (
  props: ToolboxUnselectedElementProps
) => {
  return (
    <div className={styles.container}>
      <span>{props.title}</span>
    </div>
  );
};
